import { getValidationResolver, useForm } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';

import { CreateServiceFormValues } from '../ServiceModal.types';

const useServiceForm = () => {
  const methods = useForm<CreateServiceFormValues>({
    defaultValues: {
      name: '',
      categoryType: '',
    },
    resolver: getValidationResolver({
      name: VALIDATORS.REQUIRED_STRING,
      categoryType: VALIDATORS.REQUIRED_STRING,
    }),
  });

  return { methods };
};

export default useServiceForm;
